import { INIT, models } from "../action_types";

const { UPDATE_MODELS } = models;

const initial_state = {
  user: null,
  roles: [],
};

function models_reducer(state = initial_state, actions) {
  switch (actions.type) {
    case UPDATE_MODELS:
      return {
        ...state,
        ...actions.data
      };
    case INIT:
      return initial_state;
    default:
      return state;
  };
}

export default models_reducer;
